module.exports = __webpack_public_path__ + "img/Frame-3.01e1cb8f.svg";